import { api } from '/app/plugins/services';
import { singleFlight } from '/app/utils/single-flight';
import { ref } from 'vue';

const cache = new Map();

// Do a single request for each fqdn 
const load = singleFlight(async (fqdn) => {
    const { data: response } = await api.brain.experiencePoints(fqdn);

    if (!response.data.points) {
        return null;
    }

    cache.set(fqdn, response.data.points);

    return response.data.points;
}, (fqdn) => fqdn);

export const useExperiencePoints = (key, defaultValue) => {
    const loading = ref(false);
    const points = ref(cache.get(key) || defaultValue);

    // Get experience points
    // @param  {string} fqdn (Full Qualified Domain Name)
    // role.event.meaningfulname
    const fetch = async (fqdn = key) => {
        try {
            loading.value = true;

            const value = await load(fqdn);

            if (value !== null) {
                points.value = value;
            }

            return value;
        } catch (e) {
            console.log(e)

            cache.delete(fqdn);
        } finally {
            loading.value = false;
        }
    }

    if (!cache.has(key)) {
        fetch(key);
    }

    return {
        points,
        fetch,
        loading,
    }
}
